import {
	getUserProperty,
	setUserProperties,
} from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import type { AccountId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { State } from '../types.tsx';

export const PROPERTY_KEY = 'jsm-queue-groups-state-selected-group-id';

export const setQueueGroupsStateInUserProperty = async (
	projectKey: string,
	value: State,
	accountId: AccountId,
) => {
	try {
		setUserProperties(accountId, `${PROPERTY_KEY}_${projectKey}`, JSON.stringify(value));
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: 'setQueueGroupsStateInUserPropertyError',
			},
		});
		throw error;
	}
};

export const getQueueGroupsStateFromUserProperty = async (
	projectKey: string,
	accountId: AccountId,
): Promise<State> => {
	try {
		return await getUserProperty<State>(accountId, `${PROPERTY_KEY}_${projectKey}`);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: 'getQueueGroupsStateFromUserPropertyError',
			},
		});
		throw error;
	}
};
